import { SafeHtml } from '@angular/platform-browser';
import { isEmpty } from 'lodash';

export function sanitizeStringForRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function getSearchHTML(value: number | string = '', searchValue: string): any {
  if (searchValue && searchValue.trim()) {
    return String(value).replace(
      new RegExp(sanitizeStringForRegExp(searchValue.trim()), 'ig'),
      (match) => `<mark>${match}</mark>`,
    );
  } else {
    return value;
  }
}

export function getTextWithHighlight(text, textToHighlight, className = 'highlight'): SafeHtml {
  if (isEmpty(textToHighlight) || isEmpty(text)) {
    return text;
  }

  const startHighlightIndex = text.toLocaleLowerCase().indexOf(textToHighlight.toLocaleLowerCase());
  if (startHighlightIndex !== -1) {
    const len = textToHighlight.length;
    const leftPart = text.slice(0, startHighlightIndex);
    const centerPart = text.slice(startHighlightIndex, startHighlightIndex + len);
    const rightPart = text.slice(startHighlightIndex + len);
    return `${leftPart}<span class="${className}">${centerPart}</span>${rightPart}`;
  }

  return text;
}
